import each from './each';
import append from './appendChild';
import isElement from './isElement';
import existy from './existy';

export default function createElement(tagName, props = {}, parent = null, namespace = 'http://www.w3.org/1999/xhtml') {

   let el;
   if ( existy(document.createElementNS) ) {
      el = document.createElementNS(namespace, tagName);
   } else {
      el = document.createElement(tagName);
   }

   each(props, (val, key) => {
      el.setAttribute(key, val);
   });

   if ( existy(parent) && isElement(parent) ) {
      append(parent, el);
   }

   return el;
}
